let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("bmBxo")]).then(() => parcelRequire('8V2Yz'));